/**
 * Self-Service Calculator
 *
 * Contact: dap@visana.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type Franchise = 'CHILD_0' | 'CHILD_100' | 'CHILD_200' | 'CHILD_300' | 'CHILD_400' | 'CHILD_500' | 'CHILD_600' | 'ADULT_300' | 'ADULT_500' | 'ADULT_1000' | 'ADULT_1500' | 'ADULT_2000' | 'ADULT_2500';

export const Franchise = {
    Child0: 'CHILD_0' as Franchise,
    Child100: 'CHILD_100' as Franchise,
    Child200: 'CHILD_200' as Franchise,
    Child300: 'CHILD_300' as Franchise,
    Child400: 'CHILD_400' as Franchise,
    Child500: 'CHILD_500' as Franchise,
    Child600: 'CHILD_600' as Franchise,
    Adult300: 'ADULT_300' as Franchise,
    Adult500: 'ADULT_500' as Franchise,
    Adult1000: 'ADULT_1000' as Franchise,
    Adult1500: 'ADULT_1500' as Franchise,
    Adult2000: 'ADULT_2000' as Franchise,
    Adult2500: 'ADULT_2500' as Franchise
};

